/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.leave-requests.request-allowances'},
});

const RequestAllowancesItem = () => (
  <RouteLinkItem
    route="midas/settings/leave-requests/leave-requests-allowed"
    title={messages.title}
  />
);

export default RequestAllowancesItem;
